import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '納品の最終確認',
  },
});

export const meta: PageMeta = {
  title: strings.title,
};
